import { MdOutlineBackpack } from "react-icons/md";
import styles from "./RadioButtonIconLabel.module.scss";

export default function RadioButtonIconLabel({ icon, text, fontSize }) {
  return (
    <div className={`${styles.container}`}>
      <div>{icon}</div>
      <span className={`${styles.text}`} style={{ fontSize }}>
        {text}
      </span>
    </div>
  );
}
